import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from '../../pages/admin/auth/AdminLogin';
import AdminDashboard from '../../pages/admin/dashboard/AdminDashboard';
import AdminUsers from '../../pages/admin/users/AdminUsers';
import AdminSubscriptions from '../../pages/admin/subscriptions/AdminSubscriptions';
import CreateSubscription from '../../pages/admin/subscriptions/CreateSubscription';
import EditSubscription from '../../pages/admin/subscriptions/EditSubscription';
import AdminPayments from '../../pages/admin/payments/AdminPayments';
import AdminGeideaPayments from '../../pages/admin/payments/AdminGeideaPayments';
import AdminSystemMonitor from '../../pages/admin/system/AdminSystemMonitor';
import AdminProfile from '../../pages/admin/profile/AdminProfile';
// TODO: Add when created
// import AdminPayments from '../../pages/admin/payments/AdminPayments';

// Admin route protection
const AdminProtectedRoute = ({ children }) => {
  const adminToken = localStorage.getItem('adminToken');
  
  if (!adminToken) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

// Public admin routes (login only)
const AdminPublicRoute = ({ children }) => {
  const adminToken = localStorage.getItem('adminToken');
  
  if (adminToken) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  return children;
};

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Public Admin Routes */}
      <Route 
        path="/login" 
        element={
          <AdminPublicRoute>
            <AdminLogin />
          </AdminPublicRoute>
        } 
      />
      
      {/* Protected Admin Routes */}
      <Route 
        path="/dashboard" 
        element={
          <AdminProtectedRoute>
            <AdminDashboard />
          </AdminProtectedRoute>
        } 
      />
      
      <Route 
        path="/users" 
        element={
          <AdminProtectedRoute>
            <AdminUsers />
          </AdminProtectedRoute>
        } 
      />
      
      <Route 
        path="/subscriptions" 
        element={
          <AdminProtectedRoute>
            <AdminSubscriptions />
          </AdminProtectedRoute>
        } 
      />
      
      <Route 
        path="/subscriptions/create" 
        element={
          <AdminProtectedRoute>
            <CreateSubscription />
          </AdminProtectedRoute>
        } 
      />
      
      <Route 
        path="/subscriptions/edit/:subscriptionId" 
        element={
          <AdminProtectedRoute>
            <EditSubscription />
          </AdminProtectedRoute>
        } 
      />
      
      <Route 
        path="/payments" 
        element={
          <AdminProtectedRoute>
            <AdminPayments />
          </AdminProtectedRoute>
        } 
      />
      
      <Route 
        path="/payments/geidea" 
        element={
          <AdminProtectedRoute>
            <AdminGeideaPayments />
          </AdminProtectedRoute>
        } 
      />
      
      <Route 
        path="/system" 
        element={
          <AdminProtectedRoute>
            <AdminSystemMonitor />
          </AdminProtectedRoute>
        } 
      />
      
      <Route 
        path="/profile" 
        element={
          <AdminProtectedRoute>
            <AdminProfile />
          </AdminProtectedRoute>
        } 
      />
      
      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
      
      {/* Catch all route - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
};

export default AdminRoutes; 